module.exports = __webpack_public_path__ + "img/blog-details-3.971c6205.jpg";